import { Form, Select, Tag, Tooltip } from "antd"
import { NamePath } from "antd/lib/form/interface"
import { Rule } from "antd/lib/form"
import { FC } from "react"
import { COUNTRY_CODES } from "utils/countryCodes"

export const GEO_PICKER_GLOBAL = "global"

export const isGeoPickerGlobal = (value: unknown): boolean => {
  return typeof value === "string" && value.trim().toLowerCase() === GEO_PICKER_GLOBAL
}

interface GeoPickerElementProps {
    label?: string;
    name: NamePath;
    initialValue?: string[];
    style?: React.CSSProperties;
    disabled?: boolean;
    onChange?: (value: string[]) => void;
    withGlobal?: boolean;
    rules?: Rule[];
}

const GeoPickerElement: FC<GeoPickerElementProps> = ({ label, name, initialValue, style, disabled, onChange, withGlobal, rules }) => {
  const form = Form.useFormInstance()
  const selectedValues: string[] = Form.useWatch(name, form) || initialValue || []

  const countryCodes = withGlobal ? [...COUNTRY_CODES, { code: GEO_PICKER_GLOBAL, name: "Global" }] : COUNTRY_CODES

  const isGlobalSelected = !!withGlobal && selectedValues.some(isGeoPickerGlobal)
  const toPickedValue = (value: string[]): string[] => withGlobal && value.some(isGeoPickerGlobal) ? [GEO_PICKER_GLOBAL] : value

  const options = countryCodes.map(({ code, name }) => ({
    label: `${name} (${code})`,
    value: code,
    disabled: isGlobalSelected && code !== GEO_PICKER_GLOBAL,
  }))

  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={initialValue}
      rules={rules}
      getValueFromEvent={toPickedValue}
      style={{ width: "100%" }}
    >
      <Select
        mode="tags"
        disabled={disabled}
        allowClear
        style={{ width: "100%", ...style }}
        onChange={(value: string[]) => onChange?.(toPickedValue(value))}
        placeholder="No countries selected"
        options={options}
        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        tagRender={({ closable, value, label, onClose }) => {
          const handleMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault()
            event.stopPropagation()
          }

          return (
            <Tooltip title={label}>
              <Tag
                onMouseDown={handleMouseDown}
                closable={closable}
                onClose={onClose}
                style={{ marginRight: 3, cursor: "default" }}
              >
                {value}
              </Tag>
            </Tooltip>
          )
        }}
      />
    </Form.Item>
  )
}

export default GeoPickerElement
